import React from 'react';

import SettingsContainer from '@dashboard/components/SettingsContainer';
import SettingsHeader from '@dashboard/components/SettingsHeader';
import EmailSettingsForm from './components/EmailSettingsForm';

const AccountEmails = () => {
  return (
    <SettingsContainer size="xl">
      <SettingsHeader id="email-notifications">Email notifications</SettingsHeader>

      <EmailSettingsForm />
    </SettingsContainer>
  );
};

export default AccountEmails;
